<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :tabbarIndex="1"></tabbar>
    <!-- <img width="100%" src="../../images/head.png"> -->
    <img
      style="width: 100%"
      :src="web_top_imgurl"
      @click="link(web_top_linkurl)"
      alt=""
    />

    <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>
    <div class="person">
      <div
        class="kefu"
        @click="clicked_OnlineService()"
        style="cursor: pointer"
      >
        <img
          style="margin-top: 30px; text-align: center"
          src="../../images/kefu.png"
        />
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          在线客服
        </div>
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          售后处理
        </div>
      </div>
    </div>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main flexStyle4">
      <div class="left borderShadow" ref="swiper">
        <img
          v-if="leftImg"
          :src="leftImg"
          class="img"
          style="width: 97%; height: 97%"
        />
      </div>
      <div class="right borderShadow">
        <!-- <div class="top c-animation"></div> -->
        <div class="middle">
          <div class="tabNav">
            <div class="navOne" @click="tabOne">礼品卡查询</div>
            <div class="navTwo" @click="tabTwo">手机号查询</div>
          </div>
          <!-- 这个结构是tab导航对应的内容 -->
          <div class="tabContent">
            <!-- 通过v-show控制隐藏，同一时刻隐藏一个显示一个，就实现了tab栏的切换效果了 -->
            <div class="navOneBox" v-show="showTabOne">
              <!-- <div class="middle"> -->
              <div class="item flexStyle1">
                <div class="left">卡号</div>
                <input
                  v-model="cardNum"
                  type="text"
                  class="right"
                  placeholder="请输入卡号"
                />
              </div>
              <div class="item flexStyle1">
                <div class="left">密码</div>
                <input
                  v-model="cardPwd"
                  type="password"
                  class="right"
                  placeholder="请输入密码"
                />
              </div>

              <div class="item flexStyle1" v-if="web_is_card_order_phone == 0">
                <div class="left">手机号</div>
                <input
                  v-model="phone"
                  type="text"
                  class="right"
                  placeholder="请输入手机号"
                  style="margin-left: -3px"
                />
              </div>

              <div
                class="item flexStyle1"
                style="
                  text-align: left;
                  display: flex;
                  justify-content: space-around;
                  margin-left: -20px;
                "
              >
                <div class="left" style="margin-left: -5px">验证码</div>
                <input
                  v-model="yzmCode"
                  type="text"
                  class="right right1"
                  placeholder="请输入验证码"
                  style="margin-left: -27px"
                />
                <div class="get flexStyle1">
                  <div class="left">
                    <validate-code
                      ref="ref_validateCode"
                      @change="changeCode"
                      width="140px"
                      style="margin-left: -36px; height: 100%"
                    />
                  </div>
                </div>
              </div>
              <div
                class="item flexStyle1 ch"
                style="
                  text-align: left;
                  display: flex;
                  justify-content: space-around;
                  margin-left: -20px;
                "
                v-if="web_is_card_order_phone == 0"
              >
                <div class="left" style="margin-left: -4px">短信验证码</div>
                <input
                  v-model="code"
                  type="text"
                  class="right right1"
                  placeholder="请输入验证码"
                  style="margin-left: -30px"
                />
                <div
                  @click="getPhoneCode(13)"
                  :class="getCodeSwitch ? 'get hands' : 'get get2'"
                >
                  {{ codeBtnText }}
                </div>
              </div>
              <h5 style="margin-left: -1px; width: 400px">
                订单查询说明：“本页面可通过卡号和手机号查询兑换的订单信息”
              </h5>

              <div class="bottom flexStyle1">
                <div
                  @click="parseBeforeVerifacation(1, '订单查询')"
                  class="item1 hands flexStyle1 c-animation button"
                >
                  订单查询
                </div>
              </div>
              <!-- </div> -->
            </div>
            <div class="navTwoBox" v-show="showTabTwo">
              <!-- <div class="middle"> -->
              <div class="item flexStyle1 le">
                <div class="left">手机号</div>
                <input
                  v-model="phone"
                  type="text"
                  class="right"
                  placeholder="请输入手机号"
                />
              </div>

             <div class="item flexStyle1 ch le">
                <div style="float:left"></div>
                <input
                  v-model="code"
                  type="text"
                  class="right right1"
                  placeholder="请输入验证码"
                style="margin-left:117px"/>
                <div
                  @click="getPhoneCode('message')"
                  :class="getCodeSwitch ? 'get hands' : 'get get2'"
                >
                  {{ codeBtnText }}
                </div>
                 <div
                  @click="getPhoneCode('voice')"
                  :class="getCodeSwitch ? 'get hands' : 'get get2'"
                >
                   {{ voicecodeBtnText }}
                </div>
              </div>
              <div class="item flexStyle1 le">
                <div class="left" style="margin-left: -18px">验证码</div>
                <input
                  v-model="yzmCode2"
                  type="text"
                  class="right right1"
                  placeholder="请输入验证码"
                  style="margin-left: -30px"
                />
                <div class="get flexStyle1">
                  <div class="left">
                    <validate-code
                      ref="ref_validateCode2"
                      @change="changeCode2"
                      style="margin-left: -40px"
                    />
                  </div>
                </div>
              </div>
              <!-- </div> -->
              <h5 class="two">
                订单查询说明：“本页面可通过卡号和手机号查询兑换的订单信息”
              </h5>
              <div class="bottom flexStyle1">
                <div
                  @click="parseBeforeVerifacation2(1, '订单查询')"
                  class="item1 hands flexStyle1 c-animation button1"
                >
                  订单查询
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import yzm from "@/components/yzm/yzm";
import {
  noCardsOnlyHavedPhone,
  phoneCodeRequest,
  orderFindRequest,
  getLargeClientsInfoRequest,
  urlencode,
} from "../../public/js/service";
import { Base64 } from "js-base64";

export default {
  name: "middle",
  data() {
    // 1.data
    return {
      web_rolling_notice: "", //滚动公告
      web_top_imgurl: "", // pc顶部图片链接
      web_top_linkurl: "", // pc顶部跳转链接
      showTabOne: true, // 二选一tab切换
      showTabTwo: false, // 二选一tab切换
      height: "400px", // 1.1.轮播图高度
      yzmCode: "", // 1.2.用户输入验证码数据
      checkCode: "", // 1.3.验证码正确结果
      cardNum: "", // 1.4.cardNum卡号
      cardPwd: "", // 1.5.cardPwd密码
      sysId: "", // 1.6.sysId应用ID
      bigClientId: "", // 1.7.大客户id
      leftImg: "", // 1.8.左侧广告图

      exchangeType: 0, // 1.9.0卡号订单查询1无卡号订单查询
      phone: "", // 1.10.手机号
      yzmCode2: "", // 1.11.验证码2
      checkCode2: "", // 1.12.验证码正确结果2
      codeBtnText: "获取验证码", // 1.13.验证码按钮文字
       voicecodeBtnText: "语音验证码",
      getCodeSwitch: true, // 1.14.获取验证码开关
      code: "", // 1.15.短信验证码
      web_is_card_order_phone: 0,
    };
  },

  components: {
    // 2.components
    tabbar,
    cFooter: footer,
    validateCode: yzm,
  },

  methods: {
    clicked_OnlineService() {
      var url = localStorage.web_online_service;
      if (url && url != "" && url != "#") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        var tempwindow = window.open("");
        tempwindow.location = url;
      }
    },
    tabOne() {
      /*
    点击tab1的时候，让tab1显示，tab2隐藏，即showTabOne为true，showTabTwo为false
    同时修改tab1的样式使其"高亮",注意不要忘了修改tab2的样式，使其"不高亮"。
    点击tab2的时候，也是同理。
   */
      this.showTabOne = true;
      this.showTabTwo = false;
      document.querySelector(".navOne").style.backgroundColor = "#e3e3e3";
      document.querySelector(".navTwo").style.backgroundColor = "#fff";
      document.querySelector(".navOne").style.color = "#eb3341";
      document.querySelector(".navTwo").style.color = "#000";
    },
    // 二选一tab栏切换
    tabTwo() {
      this.showTabTwo = true;
      this.showTabOne = false;
      document.querySelector(".navOne").style.backgroundColor = "#fff";
      document.querySelector(".navTwo").style.backgroundColor = "#e3e3e3";
      document.querySelector(".navTwo").style.color = "#eb3341";
      document.querySelector(".navOne").style.color = "#000";
    }, // 3.methods
    changeCode(value) {
      // 3.1.验证码改变回调函数
      this.checkCode = value;
    },

    parseBeforeVerifacation(index, name) {
      // 3.2.立即兑换or订单查询之前的验证
      // index==0立即兑换===1订单查询
      this.cTips = "buttonName:" + name;
      let verifacationResult = this.verifacation();
      if (verifacationResult) {
        if (index === 0) {
          //this.exchangeNow();
        } else if (index === 1) {
          this.watchOrderReqyest();
        }
      }
    },

    verifacation() {
      // 3.3.校验表单方法
      if (!this.cardNum.trim()) {
        // 卡号校验
        this.$notify({
          title: "提示",
          message: "请输入卡号",
        });
        return false;
      }

      if (!this.cardPwd.trim()) {
        // 卡密校验
        this.$notify({
          title: "提示",
          message: "请输入密码",
        });
        return false;
      }

      if (this.yzmCode.toUpperCase() !== this.checkCode) {
        // 随机验证码验证
        this.$notify({
          title: "提示",
          message: "请输入正确验证码",
        });
        this.yzmCode = "";
        this.$refs["ref_validateCode"].draw();
        return false;
      }
      return true;
    },

    watchOrderReqyest() {
      // 3.4.订单查询请求
      let data_pwd = this.cardPwd;
      if (localStorage.sys_pwd_secret == "1") {
        let pwd1 = Base64.encode(data_pwd);
        let pwd2 = urlencode(pwd1);
        data_pwd = pwd2;
      }
      let data = {
        sysId: this.sysId,
        cardNum: this.cardNum,
        cardPwd: data_pwd,
        code: this.code,
        phone: this.phone,
        is1: 1,
      };

      orderFindRequest(data).then((res) => {
        if (res) {
          this.$router.push(
            "/orderDetail?obj=" + encodeURIComponent(JSON.stringify(res.data))
          );
        }
      });
    },

    getCurrentPageInfoByLargeClientId() {
      // 3.5.通过大客户id获取页面数据
      let data = {
        sysId: this.sysId,
        bigClientId: this.bigClientId,
      };

      getLargeClientsInfoRequest(data).then((res) => {
        if (res) {
          let r = res.data[0];
          if (r.pc_img2) {
            this.leftImg = r.pc_img2;
          }
          if (r.show_tip == 0) {
            this.$notify({
              title: "提示",
              message: r.tip_info,
            });
          }
        }
      });
    },

    getPhoneCode(type) {
      // 3.6.获取短信验证码
      if (this.phone.trim().length != 11) {
        this.$notify({
          title: "提示",
          message: "请输入11位手机号",
        });
        return;
      }

      // let sc = 60;
      if (this.getCodeSwitch) {
        // clearInterval(this.timer);
        // this.getCodeSwitch = false;
        // this.codeBtnText = sc + "s";
         if(type=='message'){
                this.getPhoneCodeRequest();
                this.timeCode(type);
            }else{
           //语音验证码
           this.getPhoneCodeRequestvoice();
           this.timeCode(type);
            }
        // this.timer = setInterval(() => {
        //   sc--;
        //   this.codeBtnText = sc + "s";
        //   if (sc < 1) {
        //     clearInterval(this.timer);
        //     this.getCodeSwitch = true;
        //     this.codeBtnText = "获取验证码";
        //   }
        // }, 1000);
      }
    },
timeCode(type) {
      let sc = 60;
      clearInterval(this.timer);
      this.getCodeSwitch = false;
      this.timer = setInterval(() => {
        sc--;
        type == "message"
          ? (this.codeBtnText = sc + "s")
          : (this.voicecodeBtnText = sc + "s");
        if (sc < 1) {
          clearInterval(this.timer);
          this.getCodeSwitch = true;
          type == "message"
            ? (this.codeBtnText = "短信验证码")
            : (this.voicecodeBtnText = "语音验证码");
        }
      }, 1000);
    },
    getPhoneCodeRequest() {
      // 3.7.获取短信验证码请求
      let data = {
        phone: this.phone,
        sysId: this.sysId,
        type: 12,
      };

      phoneCodeRequest(data).then((res) => {
        if (res) {
          this.$message.success("短信发送成功!");
        } else {
          clearInterval(this.timer);
          this.getCodeSwitch = true;
          this.codeBtnText = "短信验证码";
        }
      });
    },
    getPhoneCodeRequestvoice() {
      // 3.7.获取短信验证码请求
      let data = {
        phone: this.phone,
        sysId: this.sysId,
        type: 12,
        type2:1
      };

      phoneCodeRequest(data).then((res) => {
        if (res) {
          this.$message.success("语音短信发送成功!");
        } else {
          clearInterval(this.timer);
          this.getCodeSwitch = true;
          this.codeBtnText = "语音验证码";
        }
      });
    },

    changeCode2(value) {
      // 3.8.验证码改变回调函数
      this.checkCode2 = value;
    },

    parseBeforeVerifacation2(index) {
      // 3.9.立即兑换or订单查询之前的验证
      // index==0立即兑换===1订单查询
      if (index != 1) {
        return;
      }

      if (this.phone.trim().length != 11) {
        // 手机号校验
        this.$notify({
          title: "提示",
          message: "请输入11位正确手机号码",
        });
        return false;
      }

      if (!this.code.trim()) {
        // 卡密短信验证码
        this.$notify({
          title: "提示",
          message: "请输入短信验证码",
        });
        return false;
      }

      if (
        this.yzmCode2 != "" &&
        this.yzmCode2.toUpperCase() !== this.checkCode2
      ) {
        // 随机验证码验证
        this.$notify({
          title: "提示",
          message: "请输入正确验证码",
        });
        this.yzmCode2 = "";
        this.$refs["ref_validateCode2"].draw();
        return false;
      }

      this.noCardFindRequest();
    },

    noCardFindRequest() {
      // 3.10.没有手机号查询订单
      let data = {
        phone: this.phone,
        code: this.code,
        sysId: this.sysId,
      };

      noCardsOnlyHavedPhone(data).then((res) => {
        if (res) {
          localStorage.token = res.data[0].token;

          let obj = res.data[0];
          obj.sysId = this.sysId;
          this.$router.push(
            "/chooseCards?parse=1&obj=" +
              encodeURIComponent(JSON.stringify(obj))
          );
        }
      });
    },
    link(url) {
      if (url != "") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
  },

  mounted() {
    // 4.mounted
    this.sysId = localStorage.sysId || ""; // 4.1.app编号
    this.bigClientId = localStorage.bigClientId || ""; // 4.2.缓存中大客户id
    this.height = this.$refs.swiper.offsetHeight + "px";
    this.leftImg = localStorage.web_bgcx || "";
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_top_imgurl = localStorage.web_top_imgurl || "";
    this.web_top_linkurl = localStorage.web_top_linkurl || "";

    this.web_is_card_order_phone = localStorage.web_is_card_order_phone || "";

    if (this.bigClientId) {
      this.getCurrentPageInfoByLargeClientId();
    }
  },

  beforeDestroy() {
    // 5.beforeDestroy
    this.leftImg = "";
  },
};
</script>
<style scoped lang="scss">
@import "./orderFind.scss";
.navOne {
  width: 30%;
  height: 100%;
  text-align: center;
  line-height: 30px;
  float: left;
  background-color: #e3e3e3;
  color: #eb3341;
}
.navTwo {
  width: 30%;
  height: 100%;
  line-height: 30px;
  text-align: center;
  float: left;
}
.navOneBox {
  //  width:  px2vw(300px);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-left: 2%;
  margin-top: 40px;
  //   align-items: center;
}
.tabNav {
  width: 200px;
  min-width: 420px;
  min-height: 30px;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: center;
  //  margin-top: 15px;
  // margin-left: 9%;
}
input {
  width: 260px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 5px;
  // margin: 20px 10px;
  padding-left: 10px;
}
.right1 {
  width: 100px;
}
.bottom {
  width: 100%;
  // height: 30px;
  // background-color: red;
  // text-align: center;
  margin-left: -15%;
}
.button {
  width: 100px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background-color: #eb3341;
  margin-top: 10px;
  margin-left: 10%;
  border-radius: 5px;
}
.button1 {
  width: 100px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background-color: #eb3341;
  margin-top: 10px;
  margin-left: 35%;
  border-radius: 5px;
}
.navTwoBox {
  width: 100%;
  margin-left: -3%;
  margin-top: 50px;
}
h5 {
  color: #eb3341;
}
.item {
  width: 400px;
  height: 50px;
  display: flex;
  justify-content: space-around;
}
.item1 {
  width: 150px;
}
.le {
  margin-left: 10%;
}
.get {
  margin-left: 7px;
}
.borderShadow {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
}
.two {
  margin-left: 55px;
}
.left {
  width: 80px;
  float: left;
  text-align: justify;
  text-align-last: justify;
}
</style>